var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 128,
    viewBox: "0 0 178 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3894_49522)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M82 128C99.673 128 115.673 120.836 127.255 109.255C138.836 97.673 146 81.673 146 64C146 46.327 138.836 30.327 127.255 18.7452C115.673 7.16345 99.673 0 82 0C64.327 0 48.327 7.16345 36.7452 18.7452C25.1635 30.327 18 46.327 18 64C18 81.673 25.1635 97.673 36.7452 109.255C48.327 120.836 64.327 128 82 128Z",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9896 117.356C96.717 117.356 110.05 111.387 119.702 101.735C129.353 92.0836 135.323 78.7503 135.323 64.0228C135.323 49.2953 129.353 35.962 119.702 26.3104C110.05 16.659 96.717 10.6895 81.9896 10.6895C67.2621 10.6895 53.9288 16.659 44.2772 26.3104C34.6258 35.962 28.6562 49.2953 28.6562 64.0228C28.6562 78.7503 34.6258 92.0836 44.2772 101.735C53.9288 111.387 67.2621 117.356 81.9896 117.356Z",
    fill: "#00C087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6562 64L76.6563 80L108.656 48",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 110.7C7.2 110.313 6.88659 110 6.5 110C6.11341 110 5.8 110.313 5.8 110.7V112.8H3.7C3.31341 112.8 3 113.113 3 113.5C3 113.887 3.31341 114.2 3.7 114.2H5.8V116.3C5.8 116.687 6.11341 117 6.5 117C6.88659 117 7.2 116.687 7.2 116.3V114.2H9.3C9.68659 114.2 10 113.887 10 113.5C10 113.113 9.68659 112.8 9.3 112.8H7.2V110.7Z",
    fill: "#E1E5F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.924 98.575C175.189 98.575 177.024 96.7394 177.024 94.475C177.024 92.2106 175.189 90.375 172.924 90.375C170.66 90.375 168.824 92.2106 168.824 94.475C168.824 96.7394 170.66 98.575 172.924 98.575Z",
    fill: "#E0F7F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.05 110.014C166.596 110.014 167.85 108.76 167.85 107.214C167.85 105.668 166.596 104.414 165.05 104.414C163.504 104.414 162.25 105.668 162.25 107.214C162.25 108.76 163.504 110.014 165.05 110.014Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 96C3.88071 96 5 94.8807 5 93.5C5 92.1193 3.88071 91 2.5 91C1.11929 91 0 92.1193 0 93.5C0 94.8807 1.11929 96 2.5 96Z",
    fill: "#00C087"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.2 27.2C167.2 26.5372 166.663 26 166 26C165.337 26 164.8 26.5372 164.8 27.2V30.8H161.2C160.537 30.8 160 31.3372 160 32C160 32.6628 160.537 33.2 161.2 33.2H164.8V36.8C164.8 37.4628 165.337 38 166 38C166.663 38 167.2 37.4628 167.2 36.8V33.2H170.8C171.463 33.2 172 32.6628 172 32C172 31.3372 171.463 30.8 170.8 30.8H167.2V27.2Z",
    fill: "#00C087"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3894_49522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSuccess);
export default __webpack_public_path__ + "static/media/account-success.b70aa9ba7730d4702f005d226f66cac4.svg";
export { ForwardRef as ReactComponent };